import axios from "axios";
import { config } from "../config";
import { userService } from "./UserService";

export class LvService {
    getRequestHeaders() {
        return {
            Authorization: `${userService.getAuthToken()}`,
            "Content-Type": "application/json",
            "x-client-type": "portal",
        };
    }

    async getClientCharts(params) {
        try {
            const result = await axios.get(`${config.apiUrl}/clientCharts/`, {
                params: params,
                headers: this.getRequestHeaders(),
            });

            return result.data;
        } catch (error) {
            console.log("error", error);
        }
    }

    // params: siteIds: number[], lineIds: number[], pathIds: number[], chartType='simple'|'detailed'
    async assignClientCharts(chartId, data) {
        try {
            const result = await axios.put(`${config.apiUrl}/clientCharts/${chartId}/assign`, data, {
                headers: this.getRequestHeaders(),
            });

            return result.data;
        } catch (error) {
            console.log("error", error);
        }
    }

    async getAssignedClientCharts(params) {
        try {
            const result = await axios.get(`${config.apiUrl}/clientCharts/byEntity`, {
                params: params,
                headers: this.getRequestHeaders(),
            });

            return result.data;
        } catch (error) {
            console.log("error", error);
        }
    }

    async getEmergencyRatingConfigSectionsByLineId(lineId) {
        try {
            const result = await axios.get(`${config.apiUrl}/emergency-rating-config/sections/line/${lineId}`, {
                headers: this.getRequestHeaders(),
            });

            return result.data;
        } catch (error) {
            console.log("error", error);
        }
    }

    async saveEmergencyRatingConfigSections(data) {
        try {
            const result = await axios.post(`${config.apiUrl}/emergency-rating-config/sections`, data, {
                headers: this.getRequestHeaders(),
            });

            return result.data;
        } catch (error) {
            console.log("error", error);
        }
    }

    async getDeviceVisibilityHistory(type, startDate, endDate) {
        try {
            const result = await axios.get(`${config.apiUrl}/devices/device_visibility_history`, {
                headers: this.getRequestHeaders(),
                params: {
                    type: type,
                    startDate: startDate,
                    endDate: endDate,
                },
            });
            return result.data;
        } catch (e) {
            console.log("error", e);
        }
    }

    async getGhiPercent(id, startDateTime, endDateTime) {
        try {
            const result = await axios.get(`${config.apiUrl}/siteGroups/ghi/${id}`, {
                headers: this.getRequestHeaders(),
                params: {
                    startDateTime: startDateTime,
                    endDateTime: endDateTime,
                },
            });
            return result;
        } catch (error) {
            console.log("error", error);
        }
    }

    async updateSiteGroupCustomerVisibilityDttm(siteGroupId, customerVisibilityDttm) {
        const result = await axios.patch(
            `${config.getApiUrl("masterdata")}/siteGroups/${siteGroupId}`,
            { customerVisibilityDttm: customerVisibilityDttm },
            { headers: this.getRequestHeaders() }
        );
        return result.data;
    }

    async getAssetObjects(deviceType) {
        try {
            const result = await axios.get(`${config.getApiUrl("masterdata")}/assets?deviceType=${deviceType}`, {
                headers: this.getRequestHeaders(),
            });
            return result;
        } catch (error) {
            console.log("error", error);
        }
    }
}

export const lvService = new LvService();
